import { useEffect } from "react";
import { useContent } from "@/context/ContentContext";

const KEYS = ["primary", "cta", "navy"]; // HSL triplet strings, es. "221 83% 53%"

export function ThemeApplier() {
  const { theme } = useContent();
  useEffect(() => {
    const root = document.documentElement;
    KEYS.forEach((k) => {
      const v = theme && theme[k];
      if (v) root.style.setProperty(`--${k}`, v);
      else root.style.removeProperty(`--${k}`);
    });
  }, [theme]);
  return null;
}
